import { useState, useEffect } from 'react';
import { ReviewWritePage } from './buyer/ReviewWritePage';
import { DesktopReviewWritePage } from './desktop/DesktopReviewWritePage';

export function ResponsiveReviewWritePage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ReviewWritePage /> : <DesktopReviewWritePage />;
}